import { axiosGet } from 'shared/api/axios'
import { apiUrls, filterValuesTypes } from 'consts'

interface getRowsProps {
  filterId: string | number
  setDeleteEntryId: Function
  setShowModal: Function
  handleSetDefault: Function
}

const getRows = async (props: getRowsProps) => {
  let url: string = apiUrls.actionGetFilterValues

  url += '?id=' + props.filterId

  const response = await axiosGet(url)

  const data = response.data

  data.forEach((row: any, index: number, dataArray: any) => {

    
    const typeObj = filterValuesTypes.find(t => t.id === dataArray[index].type) ?? null
    dataArray[index].type = typeObj !== null ? typeObj.name : dataArray[index].type 
  })

  return data
}

export default getRows
